import { Validation } from './Validation';


export default interface RentalTimeSlotJson {
   /**
    * Tageszeit zu der der Zeitraum beginnt im Format hh:mm
    */
   beginTime: string,

   /**
    * Tageszeit zu der der Zeitraum endet im Format hh:mm
    */
   endTime: string;
}

export function validateRentalTimeSlotJson(item: RentalTimeSlotJson) {
   return new Validation(item)
      .validateTime("beginTime")
      .validateTimeLaterTime("endTime", "beginTime")
      .finish();
}